import React from 'react';
import {TakeAllContestsFromAllResults} from "../ContestFunctions";
import ComponentResultsNoIMG from "../ComponentResultsNoIMG/ComponentResultsNoIMG";
import {GET_ALL_CONTEST_RESULTS,} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function QueryAllContestResults (props) {
    const { loading, error, data} = useQuery(GET_ALL_CONTEST_RESULTS, {variables : { Page : 1}});
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;
    const ArrForSort= [...data.getAllContestResults]
    const AllContestResults = ArrForSort.sort((a, b) => {if (b.ContestDate < a.ContestDate) {return -1} else {return 1}}); // Берем из базы элемент, обрабатываем в нужный формат. Превращаем в массив объектов.
    const AllContests = TakeAllContestsFromAllResults(AllContestResults,props.ThisPageContest,props.ThisPageContestDate); // Название и дату текущего конкурса - мы берем из гет-запроса. Из всех итогов мы берем даты и уникальный ИД конкурса в отдельном объекте
    if (AllContestResults.length !==0) {
        return <ComponentResultsNoIMG AllContests = {AllContests[0]} lang={props.lang} data={props.data} ContestID={AllContests[1]} CurrentYear={AllContests[2]}/>;
    } else {
        return <div/>
    }


}
export default QueryAllContestResults